module.exports = __webpack_public_path__ + "media/images/arrow_disable@2x-48bf493180b3d5dfa7b205bcdcd22ccb.png";